import { render } from "./CadastroClienteRepresentados.vue?vue&type=template&id=75e429e5&scoped=true"
import script from "./CadastroClienteRepresentados.vue?vue&type=script&lang=ts"
export * from "./CadastroClienteRepresentados.vue?vue&type=script&lang=ts"

import "./CadastroClienteRepresentados.vue?vue&type=style&index=0&id=75e429e5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-75e429e5"

export default script